<template>
  <report-container
    v-if="currentPageName === 'network-health'"
    :actions="actions"
  >
    <template v-slot:report-modals />
  </report-container>
</template>

<script>
import mixin from '../components/mixin'

export default {
  name: 'NetworkHealth',
  components: {
    ReportContainer: () => import('src/report/components/ReportContainer'),
  },
  mixins: [mixin],
  data() {
    return {
      actions: [
        {
          event: 'programmatic/openAdServerLink',
          name: 'GAM Deep Link',
        },
      ],
    }
  },
}
</script>
